import { Base_Url } from "../../BaseURL/BaseUrl";
import { postApiWithoutAuthorization } from "../ApiMethods/ApiMethod";

const loginUrl = `${Base_Url}/SuperAdminLogin/SuperAdminAuthenticate`;

export const VerifyLoginCredential = async (params) => {
  //
  const res = await postApiWithoutAuthorization(loginUrl, params);
  // const res = await Utils.LoginResponse;

  return res;
};
